import alt from "../alt";
import extend from "lodash/assign";
import AppActions from "../actions/AppActions";
import PersonActions from "../actions/PersonActions";
import AppUtil from "../utils/AppUtil";
import PersonStore from "./PersonStore";

const SHOULD_PERSIST = "localStorage" in window;
const LS_KEY = "eventive-appState";
let cachedApp;
try {
  cachedApp =
    (SHOULD_PERSIST &&
      window.localStorage[LS_KEY] &&
      JSON.parse(window.localStorage[LS_KEY])) ||
    {};
} catch (e) {
  // Catch if unable to access localstorage (e.g. due to DOM Exception 18)
  cachedApp = {};
}

class AppStore {
  constructor() {
    this.bindActions(AppActions);

    this.state = extend(
      {
        fetchSuccessful: true,
        fetchFailed: false,
        isKioskMode: false,
        isPreviewMode: false,
        isAdvanceSingleTicketsMode: false,
        kioskCode: "",
        settings: null,
        unlockInProgress: false,
        unlockErrorMessage: "",
        userEventBuckets: [],
      },
      {
        fetchSuccessful:
          cachedApp.settings && Object.keys(cachedApp.settings).length > 0,
        isPreviewMode: cachedApp.isPreviewMode,
        isKioskMode: cachedApp.isKioskMode,
        isAdvanceSingleTicketsMode: cachedApp.isAdvanceSingleTicketsMode,
        kioskCode: cachedApp.kioskCode,
        settings: cachedApp.settings
      }
    );
  }

  onSetKioskMode(mode) {
    this.setState({
      isKioskMode: mode
    });
    PersonActions.logout.defer();
  }

  onSetPreviewMode(mode) {
    this.setState({
      isPreviewMode: mode
    });
  }

  onSetAdvanceSingleTicketsMode(mode) {
    this.setState({
      isAdvanceSingleTicketsMode: mode
    });
  }

  onSetKioskCode(code) {
    this.setState({
      kioskCode: code
    });
  }

  onFetchSettings() {
    AppUtil.fetchSettings(PersonStore.getState().token)
      .then(data => {
        this.setState({ fetchSuccessful: true, settings: data });
      })
      .catch(AppActions.fetchFailed);
  }

  onFetchEventBuckets() {
    AppUtil.fetchEventBuckets(PersonStore.getState().token)
      .then(data => {
        this.setState({ fetchSuccessful: true, userEventBuckets: data });
      })
      .catch(AppActions.fetchFailed);
  }

  onFetchFailed(e) {
    this.setState({ fetchFailed: true });
    throw e;
  }

  onUpdateSettings(settings) {
    this.setState({ fetchSuccessful: true, settings: settings });
  }

  onUnlock(password) {
    this.setState({ unlockInProgress: true });

    let { token, isLoggedIn } = PersonStore.getState();

    AppUtil.unlock(token, password)
      .then(data => {
        this.setState({ unlockInProgress: false, settings: data });

        // If the user isn't logged in currently, add a hook that fires when the user
        // logs in so we can persist the unlocked state for page reloads / other browsers.
        if (!isLoggedIn) {
          PersonActions.addOneTimeLoginSucceededHook({
            fn: () => {
              AppActions.unlock.defer(password);
            }
          });
        }
      })
      .catch(AppActions.unlockFailed);
  }

  onUnlockFailed(e) {
    this.setState({ unlockInProgress: false, unlockErrorMessage: e.message });
  }
}

let store = alt.createStore(AppStore, "AppStore");

if (SHOULD_PERSIST) {
  store.listen(state => {
    try {
      window.localStorage[LS_KEY] = JSON.stringify(state);
    } catch (e) {
      // Persistence to LocalStorage failed :(
    }
  });
}

export default store;



// WEBPACK FOOTER //
// ./src/app/stores/AppStore.js